(function (window, $) {
    $('.main-menu-toggler').click(function () {
        $('#menu').slideToggle('slow');
    });
})(window, jQuery);
